module.exports = __webpack_public_path__ + "img/StudentsOnly_Interview.bca632ab.png";